/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Permission } from './Permission'

export type IntegrationUpdate = {
    /**
     * The display name of the integration
     */
    display_name?: string
    /**
     * The short name of the integration. Used for buttons and other short text.
     */
    short_name?: string
    /**
     * The description of the integration
     */
    description?: string
    /**
     * The status of the integration
     */
    status?: IntegrationUpdate.status
    /**
     * The Tithe.ly product code of the integration
     */
    product_code?: string | null
    /**
     * The Tithe.ly offer code of the integration
     */
    offer_code?: string | null
    /**
     * Builder.io ID or path
     */
    builder_io_id?: string | null
    /**
     * The permissions of the integration
     */
    permissions?: Record<string, Array<Permission>>
    /**
     * The URL of the third party app that this integration is for.
     */
    third_party_url?: string | null
    /**
     * The category of the integrations. Used by UI to group into sections.
     */
    category?: string
    /**
     * The icon of the integration
     */
    icon?: string | null
}

export namespace IntegrationUpdate {
    /**
     * The status of the integration
     */
    export enum status {
        '_0' = 0,
        '_1' = 1
    }
}
